import React, { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';

import { usePageOwner } from '../../../hooks';
import { useTimeline } from '../../../hooks/timeline/useTimeline';
import { LazyLoader } from '../../LazyLoader/LazyLoader';
import PageSection from '../../PageSection/PageSection';
import { Timeline } from '../Timeline/Timeline';

const TimelineUpdateEditorLazy = React.lazy(() =>
  import('../TimelineUpdateEditor/TimelineUpdateEditor'),
);

const TimelinePageSection: FunctionComponent = () => {
  const { timeline } = useTimeline();
  const { isPageOwner } = usePageOwner();
  const { t } = useTranslation('common', { useSuspense: false });

  if (!timeline) return null;

  // The new timeline service doesn't provide totalCount so counting nodes
  const entryCount = timeline
    ? Math.max(timeline.nodes.length, timeline.totalCount)
    : 0;

  return entryCount || isPageOwner ? (
    <PageSection
      title={t('page.timelineTitle')}
      titleId="updates"
      hasBorder={true}
    >
      {isPageOwner && (
        <LazyLoader>
          <TimelineUpdateEditorLazy />
        </LazyLoader>
      )}
      {entryCount > 0 && <Timeline />}
    </PageSection>
  ) : null;
};

export default TimelinePageSection;
